import { render, staticRenderFns } from "./FooterWrapper.vue?vue&type=template&id=78b58884&scoped=true&"
import script from "./FooterWrapper.vue?vue&type=script&lang=js&"
export * from "./FooterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FooterWrapper.vue?vue&type=style&index=0&id=78b58884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b58884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCol,VFooter})
